export default __webpack_public_path__ + "static/media/e968f30c-fe30-44c2-92d8-61e042a29258.c9668900.jpg";